import LegalPageLayout, {
  LegalList,
  LegalSection,
} from '../../components/feature/LegalPageLayout';
import { LEGAL_EMAIL, LEGAL_SITE_URL, LEGAL_UPDATED_AT } from '../../lib/legalInfo';

export default function TermsPage() {
  return (
    <LegalPageLayout
      badge="Podmienky používania"
      badgeIcon="ri-scales-3-line"
      title="Podmienky používania webu"
      lead="Tieto podmienky upravujú základné pravidlá používania webu, odosielania dopytov a práce s obsahom stránky."
      supporting="Cieľom dokumentu je nastaviť zrozumiteľný rámec medzi prevádzkovateľom webu a jeho návštevníkom."
      lastUpdated={LEGAL_UPDATED_AT}
    >
      <LegalSection title="1. Predmet dokumentu">
        <p>
          Tieto podmienky sa vzťahujú na používanie webu <strong>{LEGAL_SITE_URL}</strong>,
          prezeranie obsahu, odosielanie dopytov a základnú komunikáciu cez formulár,
          e-mail alebo iné kontaktné kanály uvedené na stránke.
        </p>
      </LegalSection>

      <LegalSection title="2. Informatívny charakter webu">
        <p>
          Obsah webu má prevažne informatívny a prezentačný charakter. Informácie o
          službách, projektoch, referenciách alebo orientačných cenách nepredstavujú
          automaticky záväznú ponuku na uzatvorenie zmluvy.
        </p>
        <p>
          K záväznej dohode o spolupráci dochádza spravidla až po individuálnej
          komunikácii, odsúhlasení rozsahu, ceny a ďalších podmienok.
        </p>
      </LegalSection>

      <LegalSection title="3. Odoslanie dopytu">
        <p>
          Odoslaním formulára alebo správy potvrdzujete, že ste uviedli pravdivé
          a relevantné údaje a že používate kontaktné kanály v súlade s právnymi
          predpismi a dobrými mravmi.
        </p>
        <LegalList
          items={[
            'odoslanie dopytu samo osebe nevytvára nárok na uzatvorenie zmluvy',
            'na dopyt odpovedám podľa kapacity a povahy zadania',
            'vyhradzujem si právo nereagovať na neúplné, zjavne nereálne alebo zneužívajúce dopyty',
          ]}
        />
      </LegalSection>

      <LegalSection title="4. Dostupnosť webu">
        <p>
          Web sa snažím udržiavať dostupný a aktuálny, no nezaručujem nepretržitú
          dostupnosť bez výpadkov alebo technických obmedzení. Môže dochádzať k
          údržbe, aktualizáciám alebo krátkodobým výpadkom.
        </p>
      </LegalSection>

      <LegalSection title="5. Zodpovednosť za obsah a odkazy">
        <p>
          Obsah webu pripravujem s dôrazom na presnosť a profesionalitu, no
          nenesiem zodpovednosť za rozhodnutia prijaté výlučne na základe všeobecných
          informácií z webu bez individuálnej konzultácie.
        </p>
        <p>
          Na webe sa môžu nachádzať aj odkazy na stránky tretích strán. Za ich
          obsah, dostupnosť a právne podmienky nenesiem zodpovednosť.
        </p>
      </LegalSection>

      <LegalSection title="6. Autorské práva">
        <p>
          Texty, návrhy, grafické prvky, fotky, kódové riešenia a ďalšie časti
          webu sú chránené autorským právom alebo inými právami duševného vlastníctva.
          Bez súhlasu ich nemožno používať spôsobom, ktorý presahuje bežné
          osobné oboznámenie sa s obsahom stránky.
        </p>
      </LegalSection>

      <LegalSection title="7. Záverečné ustanovenia">
        <p>
          Tieto podmienky môžem primerane aktualizovať podľa zmien webu, poskytovaných
          služieb alebo právnych požiadaviek. Aktuálna verzia je vždy zverejnená na tejto stránke.
        </p>
        <p>
          V prípade otázok k používaniu webu ma môžete kontaktovať na adrese{' '}
          <strong>{LEGAL_EMAIL}</strong>.
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
}
